import './App.css'
import { useEffect } from 'react'
import { Routes, Route, Link, useLocation } from 'react-router-dom'
import Home from './Pages/Home'
import Experience from './Pages/Experience'
// import Blog from './Pages/Blog'
import Contact from './Pages/Contact'
import NoMatch from './Pages/NoMatch'
import Footer from './Components/Footer'
import Dap from './Pages/Experience/Dap'
import Design from './Pages/Experience/Design'
import Other from './Pages/Experience/Other'
// import PostView from './Pages/Blog/PostView'

// Analytics
import ReactGA from 'react-ga'
const tracking_id = 'UA-123917070-1'
ReactGA.initialize(tracking_id)

function App() {
  // useLocation() to read the current URL so we can set an 'active' nav-link
  const location = useLocation()
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [location])
  const { pathname } = location
  const splitLocation = pathname.split('/')
  return (
    <div className='App bg-light text-dark container-fluid'>
      <div className={location.pathname === '/' ? 'd-none' : 'display'}>
        <nav className='navbar navbar-expand-lg navbar-light'>
          <div className='container-fluid'>
            <button
              className='navbar-toggler'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#navbarSupportedContent'
              aria-controls='navbarSupportedContent'
              aria-expanded='false'
              aria-label='Toggle navigation'>
              <span className='navbar-toggler-icon'></span>
            </button>
            <Link to='/' className='navbar-brand'>
              Jeff Heller
            </Link>
            <div
              className='collapse navbar-collapse'
              id='navbarSupportedContent'>
              <ul className='navbar-nav justify-content-start'>
                <li className='nav-item'>
                  <Link
                    className={
                      splitLocation[1] === 'experience'
                        ? 'active nav-link'
                        : 'nav-link'
                    }
                    to='experience/dap'>
                    Experience
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    className={
                      splitLocation[1] === 'contact'
                        ? 'active nav-link'
                        : 'nav-link'
                    }
                    to='contact'>
                    Contact
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    className={
                      splitLocation[1] === 'blog'
                        ? 'active nav-link disabled'
                        : 'nav-link disabled'
                    }
                    to='blog'>
                    Blog (soon)
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <main className='border-top py-3'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/experience' element={<Experience />}>
            <Route path='/experience/dap' element={<Dap />} />
            <Route path='/experience/design' element={<Design />} />
            <Route path='/experience/other' element={<Other />} />
          </Route>
          {/* <Route path='/blog' element={<Blog />}>
            <Route path='/blog/:id' element={<PostView />} />
          </Route> */}
          <Route path='/contact' element={<Contact />} />
          <Route path='/*' element={<NoMatch />} />
        </Routes>
      </main>
      <div className={location.pathname === '/' ? 'd-none' : 'display'}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default App

// TODO Run copy through an AI or grammarly type service.
// TODO Finish adding blog component and throw in a few posts
// TODO Add routing solution for gh pages 404 errors: https://github.com/rafgraph/spa-github-pages
// TODO Refactor CSS (to CSS modules?)
// TODO Add About Section + Page + Routing
// TODO Experiment dark header with yellow to mirror the home page menu (Consistent Design)
// TODO Messaging (Server)
